import { render, staticRenderFns } from "./PrevStage.vue?vue&type=template&id=37de44aa"
import script from "./PrevStage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrevStage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports